var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#6a6d71",
    stroke: "#6a6d71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M804.58 73.14H219.44v731.43h585.14V73.14z m-73.14 658.29H292.58V146.29h438.86v585.14z",
    fill: "#6a6d71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.15 621.71v256H182.87v-256h-73.15v329.15h804.57V621.71zM512 219.43H329.14v182.86H512V219.43z m-73.14 109.71h-36.57v-36.57h36.57v36.57zM548.57 219.43h146.29v73.14H548.57zM548.57 329.14h146.29v73.14H548.57zM329.14 475.43h365.71v73.14H329.14z",
    fill: "#6a6d71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.14 585.14h365.71v73.14H329.14z",
    fill: "#6a6d71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.8b937bc52ebef45f950694f25ddb5cb8.svg";
export { ForwardRef as ReactComponent };